import { service } from '@ember/service';

import Component from 'umg-ember-backend/components/record-explorer';

export default class ListCompontensTaxonomyComponent extends Component {
  // Services
  @service store;

  // Defaults
  availableFilters = [];
  defaultColumns = ['id', 'title', 'slug', 'channel'];

  tableColumns = [
    {
      property: 'id',
      sortable: true,
    },
    {
      property: 'title',
      isMainColumn: true,
    },
    {
      property: 'slug',
    },
    {
      property: 'channel',
      type: 'relation',
    },
  ];
}
